

























































































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import Draggable from 'vuedraggable'

interface ComponentData {
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  kanbanData: any[]
}

export default Vue.extend({
  name: 'Kanban',

  components: {
    Draggable
  },

  props: {

  },

  data (): ComponentData {
    return {
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      kanbanData: []
    }
  },

  watch: {},

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    getTaskByStatus (status: number): any[] {
      return this.kanbanData.filter((item: any) => item.status === status)
    },

    draggableChange (): void {

    }
  },

  created (): void {

  },

  mounted() {
    for (let i = 0; i < 50; i++) {
      const status = Math.floor(Math.random() * 5) + 1
      this.kanbanData.push({id: i, title: `Task${i}`, text: `Text to task${i}`, status: status})
    }

  }
})
